var map = {
	"./arrow-right.svg": 153,
	"./chat.svg": 5166,
	"./checked.svg": 2173,
	"./colored-logo.svg": 3646,
	"./footer-logo.svg": 9338,
	"./heart.svg": 3972,
	"./home/circle.svg": 9168,
	"./home/lock.svg": 5215,
	"./home/protect.svg": 5563,
	"./home/rec.svg": 715,
	"./light.svg": 1821,
	"./logo.svg": 3190,
	"./main-rec.svg": 1635,
	"./main-rec2.svg": 3745,
	"./main-rec3.svg": 4754,
	"./main-rec4.svg": 7921,
	"./main-rec5.svg": 9267,
	"./main-rec6.svg": 7334,
	"./people.svg": 7414,
	"./star.svg": 3740,
	"./walked.svg": 2655
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7254;